import { useTranslation } from 'react-i18next'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Footer = ({ acceptedCount, onConfirm, disabled, loading }) => {
  const { t } = useTranslation()

  return (
    <Styles.Footer>
      <Styles.CountText>{t('{{count}} sugerencias a aplicar', { count: acceptedCount })}</Styles.CountText>
      <ButtonWithSpinner
        onClick={onConfirm}
        disabled={disabled}
        defaultLabel={t('Actualizar inventario')}
        loadingLabel={t('Actualizando inventario...')}
        loading={loading}
      />
    </Styles.Footer>
  )
}

export default Footer
